export default __webpack_public_path__ + "static/media/1680.6cd77560.png";